import React from 'react';
import PropTypes from 'prop-types';
import { DepotDirectService } from './DepotDirectService';
import { ShippingService } from './ShippingService';
import { ResponseOnly } from './subcomponents/responseOnly/ResponseOnly';
import { useIsMajorAppliance } from '../helpers/useIsMajorAppliance';
import { CheckAvailabilityProvider } from '../CheckAvailabilityContext';
import { dataModel } from './dataModel';
import '../styles/check-availability.scss';

const CheckAvailability = (props) => {
  const {
    responseOnly
  } = props;

  const { isMajorApplianceItemOrItems, loading, error } = useIsMajorAppliance(props);

  if (!responseOnly && (loading || error)) return null;

  return (
    <CheckAvailabilityProvider
      { ...props } // eslint-disable-line
      isMajorApplianceItemOrItems={isMajorApplianceItemOrItems}
    >
      <div className="check-availability">
        { !responseOnly
          && typeof isMajorApplianceItemOrItems === 'boolean'
          && !loading
          && !error
          && (
            isMajorApplianceItemOrItems ? <DepotDirectService /> : <ShippingService />
          )}
        { responseOnly && <ResponseOnly /> }
      </div>
    </CheckAvailabilityProvider>
  );
};

CheckAvailability.propTypes = {
  /** Product ID */
  itemId: PropTypes.string,
  /** Product ID's for checking availability for a bundle or package */
  itemIds: PropTypes.arrayOf(PropTypes.string),
  /** used in conjunction with responseOnly to associate which api call belongs to the individual item */
  queryIds: PropTypes.arrayOf(PropTypes.string),
  /** while we show the form */
  onError: PropTypes.func,
  /** while we show the form */
  onSubmitForm: PropTypes.func,
  /** Price */
  price: PropTypes.number,
  /** Quantity */
  quantity: PropTypes.number,
  /** ZIP code to check availability */
  zipCode: PropTypes.string,
  /** store id to check availability */
  storeId: PropTypes.string,
  /** for rendering a hidden check availability component that is
   * triggered by the onSubmit event of another CA input */
  responseOnly: PropTypes.bool,
  /** if zipcode exists in cookie or is passed in, check the availability on mount */
  autoCheck: PropTypes.bool,
  /** hides the input from the user and because reactionary to an event */
  hideInput: PropTypes.bool,
  /** can be used in conjunction with hideInput so that the only thing that
   * appears is the availability message when its ready */
  showLoader: PropTypes.bool,
  /** to place a title above the input box */
  inputHeaderTitle: PropTypes.string,
  /** show the response message in this component.
   * false allows user to use custom messaging from callback data */
  defaultMessaging: PropTypes.bool,
  /** specify if this component is used for a bundles availability */
  isBundle: PropTypes.bool,
  /** specify if this component is used for a packages availability */
  isPackage: PropTypes.bool,
  /** Prevent and bypass an unnecessary useProduct call if itemType(s) are already known */
  isMajorAppliance: PropTypes.bool
};

CheckAvailability.defaultProps = {
  itemId: '',
  itemIds: null,
  queryIds: null,
  onError: null,
  onSubmitForm: null,
  price: 0,
  quantity: 1,
  zipCode: '',
  storeId: '121',
  responseOnly: false,
  autoCheck: false,
  hideInput: false,
  showLoader: true,
  inputHeaderTitle: null,
  defaultMessaging: true,
  isBundle: false,
  isPackage: false,
  isMajorAppliance: false
};

CheckAvailability.dataModel = dataModel;
export default CheckAvailability;